const e = "border border-grey-200 rounded-lg px-4 py-2 w-full max-w-full text-base text-grey-600 appearance-none focus:outline-none focus:none", o = "h-12";
export {
  e as baseStyles,
  o as heightStyles
};
